import { LoadableAfterPaint, LoadablePaint } from '@confluence/loadable';

export const ArchiveSpacePortal = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ArchiveSpacePortal" */ './ArchiveSpacePortal'))
			.ArchiveSpacePortal,
	name: 'ArchiveSpacePortal',
});

export const ArchiveSpacePanel = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ArchiveSpacePanel" */ './ArchiveSpacePanel'))
			.ArchiveSpacePanel,
	name: 'ArchiveSpacePanel',
});
